import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';

type DismissTransactionArg = {
  transactionId: string;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: DismissTransactionArg }
): Promise<void> => {
  const { transactionId } = arg;
  await denApi.post<{ success: boolean }, Record<string, never>>(
    `transactions/${encodeURIComponent(transactionId)}/dismiss`,
    {}
  );
};

export function useDismissTransaction(
  swrOptions?: SWRMutationConfiguration<
    void,
    Error,
    string,
    DismissTransactionArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    void,
    Error,
    string,
    DismissTransactionArg
  >('transactions/dismiss', fetcher, swrOptions);

  return { dismissTransaction: trigger, isLoading: isMutating, error };
}
